import { Layout as AdminLayout } from "react-admin"
import Menu from "src/common/Menu"

export const Layout = (props) => <AdminLayout {...props} menu={Menu} />
